import React from 'react';
import { Link } from 'react-router-dom';
import { H2 } from '@hub/heading';
import { LocationDropPinMediumIcon } from '@hub/icon';
import { UnorderedList, ListItem } from '@hub/list';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const CentreLinks = _ref => {
  let {
    centres,
    header,
    mode
  } = _ref;
  const paddingLeft = mode === 'search' ? 'spacing-md' : undefined;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(H2, {
      sx: {
        paddingLeft,
        fontSize: 'font-md',
        fontWeight: 'bolder',
        paddingTop: 'spacing-md'
      },
      "data-id": "new-centre-selector_centre-links_CentreLinks_H2",
      children: header
    }), /*#__PURE__*/_jsx(UnorderedList, {
      sx: {
        listStyle: 'none',
        margin: 'spacing-none',
        padding: 'spacing-none'
      },
      "data-id": "new-centre-selector_centre-links_CentreLinks_UnorderedList",
      children: centres.map(centre => /*#__PURE__*/_jsx(ListItem, {
        sx: {
          paddingLeft,
          paddingTop: 'spacing-sm',
          '&:hover, &:focus-within': {
            background: 'smoke',
            cursor: 'pointer'
          },
          paddingBottom: 'spacing-sm'
        },
        "data-id": "new-centre-selector_centre-links_CentreLinks_ListItem",
        children: /*#__PURE__*/_jsxs(Link, {
          to: "/".concat(centre.slug),
          style: {
            display: 'flex',
            alignItems: 'center'
          },
          "data-id": "new-centre-selector_centre-links_CentreLinks_ListItem_Link",
          children: [/*#__PURE__*/_jsx(LocationDropPinMediumIcon, {
            sx: {
              marginRight: 'spacing-sm'
            },
            boxSize: "size-icon-sm",
            ariaLabel: "location drop pin icon",
            "data-id": "new-centre-selector_centre-links_CentreLinks_Link_LocationDropPinMediumIcon"
          }), centre.title]
        })
      }, centre.sys.id))
    })]
  });
};

export default CentreLinks;